// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profileModal-container {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  max-width: 80%;\n  justify-content: center;\n  min-height: auto;\n  padding: 25px;\n}\n.identicon {\n  border-radius: 50%;\n}\n.avator-big {\n  width: 5rem !important;\n  height: 5rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
